/* ---- Network Requests ---- */
/**
 * Fetch the catalog item data from reware based on provided parent SKU inputted by user.
 * @param {*} parentSku
 * @param {*} partnerUuid
 * @returns
 */
async function fetchSku(parentSku, partnerUuid) {
  const query = `
    query tradeinItemConditionValues(
      $partnerUuid: String!
      $parentSku: String!
      $displayType: String!
    ) {
      tradeinItemConditionValues(partnerUuid: $partnerUuid, parentSku: $parentSku, displayType: $displayType) {
        parentSku,
        catalogItemTitle,
        itemImageUrl
        availabilityMiti
        conditionValues {
          tradeinValue
          condition {
            name
            displayName
            rank
          }
        }
      }
    }
  `;
  const variables = {
    partnerUuid,
    parentSku,
    displayType: 'miti'
  };

  const param = 'query-tradeinItemConditionValues';
  try {
    const response = await fetchWithAppName(`${global.url}${param}`, {
      body: JSON.stringify({ query, variables }),
    });
    const jsonData = await response.json();
    const { tradeinItemConditionValues } = jsonData.data;

    const isKnownItemSku = Object.values(tradeinItemConditionValues).every(property => property !== null);

    if (!isKnownItemSku) {
      return null;
    }

    if (tradeinItemConditionValues.availabilityMiti === 'INELIGIBLE') {
      return 'ineligible';
    }

    return tradeinItemConditionValues;
  } catch (e) {
    console.error(e);
    return null;
  }
}

/**
 * Fetch the data from reware needed to display necessary form options (item departments,
 * categories, and trade-in values for each condition).
 *
 * @param {*} partnerUuid
 * @returns
 */
async function fetchDepartmentData(partnerUuid) {
  const query = `
    query tradeinDepartmentsFetch(
      $partnerUuid: String!
    ) {
      tradeinDepartments(partnerUuid: $partnerUuid) {
        name
        categories {
          name
          conditions {
            tradeinValue
            condition {
              name
              displayName
              rank
            }
          }
        }
      }
    }
  `;
  const param = 'query-tradeinDepartmentsFetch';
  try {
    const response = await fetchWithAppName(`${global.url}${param}`, {
      body: JSON.stringify({ query, variables: { partnerUuid } }),
    });
    const jsonData = await response.json();
    return jsonData.data;
  } catch (e) {
    console.log(e);
  }
}

/* ---- DOM manipulation ---- */
const formInput = document.getElementById('search-area__input');
const searchButton = document.getElementById('search-area__submit-button');

const knownItemSection = document.querySelector('.trade-in-search .known-item');
const unknownItemSection = document.querySelector('.trade-in-search .unknown-item');

const addItemDetails = document.querySelector('.search-area__add-item-details') || document.getElementById('search-area__add-item-details');
const hideItemDetails = document.querySelector('.search-area__hide-item-details') || document.getElementById('search-area__hide-item-details');

const tradeinSearchForm = document.querySelector('trade-in-product-form');
const submitButtonContainer = document.querySelector('.trade-in-search-form__submit-button-container');
const addItemSubmitButton = document.getElementById('add-trade-in-item-button');
const styleNumberModal = document.querySelector('.style-number-modal');
const styleNumberOverlay = document.querySelector('.style-number-modal-overlay');
const searchAreaBodyP = document.querySelector('.search_area__body > p');
const styleModalClose = document.querySelector('.modal-close');
const [elegibleModalTrigger, styleModalTrigger] = searchAreaBodyP.getElementsByTagName('a');
const eligibilityModal = document.querySelector('.eligibility-modal');
const eleigibilityModalClose = document.querySelector('.eligibility-modal-close');
const eleigibilityOverlay = document.querySelector('.eligibility-modal-overlay');

function renderConditionModalOpeners(conditions, initialConditionEl, conditionListEl) {
  const conditionElements = conditions?.map((condition, i) => {
    const thisConditionEl = i === 0 ? initialConditionEl : initialConditionEl.cloneNode(true);
    const {
      tradeinValue,
      condition: {
        displayName,
        rank
      }
    } = condition;
    thisConditionEl.setAttribute('data-condition-rank', `${rank}`);

    thisConditionEl.querySelector('modal-opener').setAttribute('data-modal', `#modal-condition-rank-${rank}`);
    thisConditionEl.querySelector('.condition-name').innerHTML = displayName;
    const displayValue = tradeinValue ?
      ` - ${formatCurrency(tradeinValue)}` :
      '';

    thisConditionEl.querySelector('.condition-value').innerHTML = displayValue;
    return thisConditionEl;
  });

  conditionListEl.replaceChildren(...conditionElements);
  conditionListEl.classList.remove('hidden');
}

async function submitSearch(e) {
  e.preventDefault();
  const searchErrorMsg = document.getElementById('search-area__error-message');
  const knownItemSection = document.querySelector('.trade-in-search .known-item');
  const unknownItemSection = document.querySelector('.trade-in-search .unknown-item');
  const loadingElement = document.querySelector('.trade-in-search .loading-area');
  const findingYourStyleNumberSection = document.getElementById('finding-your-style-number');
  const noStyleNoProblemSection = document.getElementById('no-style-no-problem');
  const searchItemUnknownMessage = document.querySelector('.trade-in-search .search-area__unknown-item');
  const ineligibleItemMessage = document.querySelector('.trade-in-search .search-area__unavailable-item');
  const searchItemUnknownButton = document.querySelector('.search_area__add-item-button');

  knownItemSection.classList.add('hidden');
  unknownItemSection.classList.add('hidden');
  searchErrorMsg.classList.add('hidden');
  searchItemUnknownMessage.classList.add('hidden');
  ineligibleItemMessage.classList.add('hidden');
  submitButtonContainer.classList.add('hidden');
  addItemSubmitButton.disabled = false;

  const regexp = new RegExp(formInput.getAttribute('data-regexp-test'));
  if (!regexp.test(formInput.value)) {
    console.log('failed the regexp');
    return (searchErrorMsg.classList.remove('hidden'));
  }

  // Fetch the item from reware
  loadingElement.classList.remove('hidden');
  const knownTradeinItem = await fetchSku(formInput.value, global.partnerUuid);
  loadingElement.classList.add('hidden');

  if (knownTradeinItem) {
    if (knownTradeinItem === 'ineligible') {
      ineligibleItemMessage?.classList?.remove('hidden');
    } else {
      tradeinSearchForm.setIsKnownItem(true);
      document.querySelector('.known-item__body-details .item-name').innerHTML = knownTradeinItem.catalogItemTitle;
      document.querySelector('.known-item__body-details .item-sku').innerHTML =
        `${document.querySelector('.known-item__body-details .item-sku-descriptor.hidden').innerHTML}${knownTradeinItem.parentSku}`;

      const imageContainer = document.querySelector('.known-item__body-media');
      const imageElement = document.createElement('img');
      const itemImageUrl = knownTradeinItem?.itemImageUrl;
      imageElement.setAttribute('src', normalizeUrl(itemImageUrl, { width: '300', height: '300' }));
      imageElement.setAttribute('alt', "known parent sku item");
      imageElement.setAttribute('onerror', `this.onerror=null; this.src='${localStorage.getItem('cameraShyImageUrl')}'`);
      imageContainer.replaceChildren(imageElement);

      const conditionEl = document.querySelector('.known-item__body-conditions .condition');
      renderConditionModalOpeners(knownTradeinItem.conditionValues, conditionEl, conditionEl.parentNode);

      knownItemSection.classList.remove('hidden');
      submitButtonContainer.classList.remove('hidden');
      findingYourStyleNumberSection?.classList?.add('hidden');
      noStyleNoProblemSection?.classList?.add('hidden');
      searchItemUnknownButton?.classList?.add('hidden');
    }
  } else {
    tradeinSearchForm.setIsKnownItem(false);
    searchItemUnknownMessage.classList.remove('hidden');
    searchItemUnknownButton?.classList?.remove('hidden');
    findingYourStyleNumberSection?.classList?.add('hidden');
    noStyleNoProblemSection?.classList?.add('hidden');
  }
}

async function showUnknownItemForm() {
  addItemDetails.classList.add('hidden');

  const departmentData = await fetchDepartmentData(global.partnerUuid);
  let selectedDepartment;
  let selectedCategory;
  const categorySelect = document.getElementById('category-select');
  const categoryPlaceholderOption = document.querySelector('#category-select option[value=""]');

  addItemSubmitButton.disabled = true;

  const handleSelectDepartment = departmentName => e => {
    selectedDepartment = departmentData.tradeinDepartments.find(dept => dept.name === departmentName);
    const availableCategories = selectedDepartment.categories.map(category => category.name);
    const categoryOptions = availableCategories.map(category => {
      const option = document.createElement('option');
      option.textContent = category;
      option.value = category;
      return option;
    });

    categorySelect.replaceChildren(categoryPlaceholderOption, ...categoryOptions);
    categorySelect.value = '';
    categorySelect.dispatchEvent(new Event('change'));
  };

  const handleSelectCategory = e => {
    if (!selectedDepartment) {
      console.warn('Department has not been selected yet.');
      return;
    }

    const conditionList = document.querySelector('.unknown-item__conditions');
    if (e.target.value === '') {
      conditionList.classList.add('hidden');
      return;
    }

    // create list of condition elements and tradein values
    selectedCategory = selectedDepartment.categories.find(cat => cat.name === e.target.value);
    availableConditions = selectedCategory.conditions;
    conditionList.classList.remove('hidden');

    const conditionEl = document.querySelector('.unknown-item__conditions .condition');

    renderConditionModalOpeners(availableConditions, conditionEl, conditionEl.parentNode);
  };

  const departmentButtonsContainer = document.querySelector('.unknown-item__department-buttons');
  const departmentButtons = departmentData.tradeinDepartments.map((department, index) => {
    const departmentButton = document.createElement('input');
    departmentButton.setAttribute('value', department.name);
    departmentButton.setAttribute('type', 'radio');
    departmentButton.setAttribute('name', 'department');
    departmentButton.setAttribute('id', `department-${index}`);

    if (index === 0) {
      departmentButton.setAttribute('checked', true);
    }

    const departmentLabel = document.createElement('label');
    departmentButton.classList.add('department-button', 'form-input');
    departmentLabel.setAttribute('for', `department-${index}`);
    departmentLabel.innerHTML = department.name;
    departmentButton.addEventListener('click', handleSelectDepartment(department.name));

    const radioButtonContainer = document.createElement('span');
    radioButtonContainer.setAttribute('class', 'button--radio-button');
    radioButtonContainer.appendChild(departmentButton);
    radioButtonContainer.appendChild(departmentLabel);
    return radioButtonContainer;
  });

  departmentButtonsContainer.replaceChildren(...departmentButtons);
  departmentButtons[0].querySelector('input').click(); // select the first department option by default

  categorySelect.addEventListener('change', handleSelectCategory);

  hideItemDetails.classList.remove('hidden');
  unknownItemSection.classList.remove('hidden');
  submitButtonContainer.classList.remove('hidden');
}

function hideUnknownItemForm() {
  addItemDetails.classList.remove('hidden');
  hideItemDetails.classList.add('hidden');
  unknownItemSection.classList.add('hidden');
  submitButtonContainer.classList.add('hidden');
}

function handleDisableSubmitButton() {
  const addItemSubmitButton = document.getElementById('add-trade-in-item-button');
  const inputs = document.querySelectorAll('.form-input');

  const isFormFilled = [...inputs].every(input => {
    if (input.type === 'checkbox') {
      return input.checked;
    }
    if (input.type === 'radio' && input.checked) {
      return input.checked;
    }
    return Boolean(input.value);
  });

  if (isFormFilled) {
    addItemSubmitButton.disabled = false;
  } else {
    addItemSubmitButton.disabled = true;
  }
}

function openStyleModal() {
  styleNumberModal.classList.add('style-number-modal-open');
}

function openEligibilityModal() {
  eligibilityModal.classList.add('eligibility-modal-open');
}

function closeStyleModal() {
  styleNumberModal.classList.remove('style-number-modal-open');
}

function closeEligibilityModal() {
  eligibilityModal.classList.remove('eligibility-modal-open');
}

document.querySelectorAll('.form-input').forEach(input => {
  input.addEventListener('change', handleDisableSubmitButton)
});

searchButton.addEventListener('click', submitSearch);
searchButton.addEventListener('keypress', (event) => a11yKeyPress(event, submitSearch));
formInput.addEventListener('keypress', (event) => a11yKeyPress(event, submitSearch, false));

addItemDetails.addEventListener('click', showUnknownItemForm);
hideItemDetails.addEventListener('click', hideUnknownItemForm);

//Style number modal listeners
styleModalTrigger.addEventListener('click', openStyleModal);
styleNumberOverlay.addEventListener('click', closeStyleModal);
styleModalClose.addEventListener('click', closeStyleModal);

//Condition modal listeners
elegibleModalTrigger.addEventListener('click', openEligibilityModal);
eleigibilityModalClose.addEventListener('click', closeEligibilityModal);
eleigibilityOverlay.addEventListener('click', closeEligibilityModal);

